import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

// Section 1
const START_DATE = 'start_date'
const END_DATE = 'end_date'
const STATUS = 'status'
const GOALS = 'goals'

const today = new Date()
today.setHours(0, 0, 0, 0)

/**
 * Form model
 */
const formModel = () => {
  return {
    [START_DATE]: {
      label: `Start Date`,
      name: START_DATE,
      required: true,
    },
    [END_DATE]: {
      label: `End Date`,
      name: END_DATE,
    },
    [STATUS]: {
      label: `Status`,
      name: STATUS,
    },
    [GOALS]: {
      label: `Goals`,
      name: GOALS,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [START_DATE]: null,
  [END_DATE]: false,
  [STATUS]: '',
  [GOALS]: '',
}


export default formModel
